import React, { useState } from 'react';
import ApiPaginationTable from 'modules/Tables/ApiPaginationTable';
import Input from '@hubins/components/Input';
import Button, { ButtonWrap } from '@hubins/components/Button';
import Modal from '@hubins/components/Modal';
import { LoadingBar } from '@hubins/components/LoadingIndicators';
import middleman from '@hubins/middleman';
import __ from 'localisation';

const loadingObj = {
  name: <LoadingBar small />,
  national_identity_number: <LoadingBar small />,
};

const loadingState = [
  loadingObj,
  loadingObj,
  loadingObj,
];

const AddBrokerModal = ({ open, setOpen, portfolioUuid }) => {

  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
  const [amountOfPages, setAmountOfPages] = useState(-1);
  const [users, setUsers] = useState([]);
  const [searchValue, setSearchValue] = useState('');


  const addUser = async (user) => {
    if (confirm(`Are u sure you want to add ${user.name} as broker?`)) {
      setLoading(true);
      try {
        await middleman.post(`/ql/crm/portfolio/add-broker/${portfolioUuid}`, {
          userUuid: user.uuid,
        });
        setLoading(false);
        window.location.reload();
      } catch (e) {
        setLoading(false);
        console.error(e.message);
      }
    }
  };

  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'National identity number',
      accessor: 'national_identity_number',
    },
    {
      Header: 'Add user',
      Cell: ({ row }) => {
        return (
          <Button
            onClick={() => {
              addUser(row.original);
            }}
            loading={loading}
            disabled={loading}
          >
            Add
          </Button>
        );
      }
    }
  ];

  const fetchPage = async (page, searchParam = '') => {
    setLoading(true);
    setSelectedPage(page - 1);
    const res = await middleman.get(`/ql/crm/user/search?page=${page}&role=broker${searchParam ? `&search=${searchParam}` : ''}`);
    setAmountOfPages(res.data.last_page);
    setUsers(res.data.data);
    setLoading(false);
  };

  const handlePageFetch = (index) => {
    fetchPage(index + 1, searchValue);
  };

  return (
    <Modal open={open} callback={setOpen} closeButton>
          <Input
            label="Search"
            value={searchValue}
            callback={(value) => setSearchValue(value as string)}
            className="s-top-xl"
          />
          <ButtonWrap>
            <Button
              onClick={() => { fetchPage(1, searchValue); }}
              loading={loading}
              className='s-bottom-xl s-top-md'
            >
              Search
            </Button>
          </ButtonWrap>
          <ApiPaginationTable
            data={users ? users : loadingState}
            headers={columns}
            fetchData={handlePageFetch}
            pageCount={amountOfPages}
            index={selectedPage}
          />
    </Modal>
  );
};

export default AddBrokerModal;